module.exports = __webpack_public_path__ + "img/t2-14.dd60c9fb.svg";